import React from "react";
import {
  criarSetorAtendimentoProtocoloDs,
  inserirOuAtualizar,
} from "../../DataSources.js";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import Memoria from "../../Memoria";
import notify from "devextreme/ui/notify";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import apiAxios from "../../api-axios";
import ShowError from "../../AppServices.js";

const template = {
  id: undefined,
  prefeituraId: UserInfo.getPrefeitura(),
  nome: "",
};

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

export default class SetorAtendimentoProtocoloForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.setorAtendimentoProtocoloDs = criarSetorAtendimentoProtocoloDs();
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.setorAtendimentoProtocoloDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (data == undefined) {
            notify("Registro não encontrado.", "error");
            this.props.history.push("/setoratendimentoprotocolo");
          }

          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem caption="DADOS DO SETOR" colSpan={2} colCount={4}>
                <SimpleItem colSpan={1} dataField={"nome"} />
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }

  async ok() {
    if (UserInfo.getUsuarioId() === undefined)
      notify("Usuário precisa selecionar prefeitura!", "warning");
    else {
      try {
        const entidade = this.state;

        const response = await apiAxios.post(
          `protocolos/setores/inserir`,
          entidade
        );
        console.log("tempo");
        if (response.status === 200) {
          notify("Status de Protocolo cadastrado com sucesso!", "success");
        }
      } catch (error) {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      }
      this.props.history.push(`/setoratendimentoprotocolo`);
    }
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
